export default "__VITE_ASSET__Bcux7ErB__"